<template>
  <!--<div id="indexBox">-->
  <!--<el-container class="wmCloudsWrapper">-->
  <!--<app-header></app-header>-->
  <!--<div id="layoutBoxMail">-->
    <!--<el-container class="wmCloudsContant">-->
      <!--&lt;!&ndash; 邮箱左侧导航 &ndash;&gt;-->
      <!--<app-aside></app-aside>-->
      <!--&lt;!&ndash; 设置左侧导航 &ndash;&gt;-->
      <!--<asideSet style="display:none;"></asideSet>-->
      <el-container>
        <div class="flexbox wmCloudsMain">
          <div class="wmCloudsBox">
            <!-- 操作栏 -->
            <div class="actionBar flexBetween">
              <!-- 左侧 -->
              <div class="actionBarLeft">
                <!-- 全选按钮 -->
                <el-dropdown @command="checkedCommand" v-show="showToolAllCheck" size="small" class="actionDropdown">
                  <el-button size="small">
                    <el-checkbox @click.native.stop="stopBubble($event)" @change.native="handleAllChecked($event)"></el-checkbox><i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown" class="el-dropdown-ej">
                    <el-dropdown-item command="all">{{$t("wm_lang_html_66eeac")}}</el-dropdown-item>
                    <el-dropdown-item command="reverse">{{$t("wm_lang_html_aab57a")}}</el-dropdown-item>
                    <el-dropdown-item command="not">{{$t("wm_lang_html_6297bc")}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- 刷新 -->
                <el-button-group class="ml10 actionBtnGroup">
                  <el-button size="small" @click.native="refreshList">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_694fc5")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_694fc5')" placement="top">
                      <i class="icon el-icon-recall"></i>
                    </el-tooltip>
                  </el-button>
                </el-button-group>
                <!-- 邮件按钮 -->
                <el-button-group v-show="moreActionBar" class="ml10 actionBtnGroup">
                  <el-button size="small" @click.native="toWrite">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_e9e805")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_e9e805')" placement="top">
                      <i class="icon el-icon-message"></i>
                    </el-tooltip>
                  </el-button>
                </el-button-group>
                <!-- 保存按钮 -->
                <!--<el-button-group v-show="moreActionBar" class="ml10 actionBtnGroup">-->
                  <!--<el-button size="small" @click.native="attachDownload">-->
                    <!--<span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_f26ef9")}}</span>-->
                    <!--<el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" content=this.$i18n.t('wm_lang_f26ef9') placement="top">-->
                    <!--<i class="icon el-icon-save"></i>-->
                    <!--</el-tooltip>-->
                  <!--</el-button>-->
                <!--</el-button-group>-->
                <!-- 删除按钮 -->
                <el-button-group v-show="moreActionBar" class="ml10 actionBtnGroup">
                  <el-button size="small" @click.native="attachDelete">
                    <span v-if="!confDisplaySetting.toolbarButtonIcon">{{$t("wm_lang_html_2f4aad")}}</span>
                    <el-tooltip v-if="confDisplaySetting.toolbarButtonIcon" :content="$i18n.t('wm_lang_2f4aad')" placement="top">
                      <i class="icon el-icon-del"></i>
                    </el-tooltip>
                  </el-button>
                </el-button-group>
              </div>
              <!-- 右侧 （列表布局时启用）-->
              <!--<div class="actionBarRight flexBetween">-->
                <!--<el-dropdown size="medium" trigger="click" class="mr20">-->
                  <!--<span class="el-dropdown-link">-->
                    <!--1/5页<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                  <!--</span>-->
                  <!--<el-dropdown-menu slot="dropdown" style="max-height:150px;overflow:auto;" class="nice_scroll">-->
                    <!--<el-dropdown-item class="active">1/5</el-dropdown-item>-->
                    <!--<el-dropdown-item>2/5</el-dropdown-item>-->
                    <!--<el-dropdown-item>3/5</el-dropdown-item>-->
                    <!--<el-dropdown-item>4/5</el-dropdown-item>-->
                    <!--<el-dropdown-item>5/5</el-dropdown-item>-->
                  <!--</el-dropdown-menu>-->
                <!--</el-dropdown>-->
                <!--<el-link :underline="false"><i class="el-icon-arrow-left mr10 f18"></i></el-link>-->
                <!--<el-link :underline="false"><i class="el-icon-arrow-right mr10 f18"></i></el-link>-->
              <!--</div>-->
            </div>
            <!-- 页码栏 -->
            <div class="maiTxt outfullsearch p0-p15">
              <div class="flexBetween">
                <div style="table-layout:fixed;word-break:break-all;">
                  <span class="crumbs outFullSearch" style=" word-wrap: break-word; overflow:hidden;">{{$t("wm_lang_html_d9cc43")}}:{{bytesToSize(totalSize)}}({{$t("wm_lang_html_b59b00")}}{{bytesToSize(usedSize)}}, {{getPercent(usedSize, totalSize)+ '%'}}) {{$t("wm_lang_html_1d4403")}}{{expDays}}{{$t("wm_lang_html_249aba")}}</span>
                </div>
                <!-- 分页 -->
                <div class="listBarPag">
                  <el-dropdown size="medium" trigger="click" class="mr20" @command="handlePageTurn">
                  <span class="el-dropdown-link">
                    {{currentPage}}/{{totalPages}}{{$i18n.t('comm_lang_0014')}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                    <el-dropdown-menu slot="dropdown" style="max-height:150px;overflow:auto;" class="nice_scroll">
                      <!--<el-dropdown-item class="active">1/5</el-dropdown-item>-->
                      <el-dropdown-item :command="item.c" v-for="(item, index) in pageNumbers" :key="index">{{item.c}}/{{item.t}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-link :underline="false" @click="pageTurn('prev')"><i :class="getTurnPrevFlag() ? 'el-icon-arrow-left mr10 f18 disabled' : 'el-icon-arrow-left mr10 f18'"></i></el-link>
                  <el-link :underline="false" @click="pageTurn('next')"><i :class="getTurnNextFlag() ? 'el-icon-arrow-right mr10 f18 disabled' : 'el-icon-arrow-right mr10 f18'"></i></el-link>
                </div>
              </div>
            </div>
            <!-- 如下代码需要做判断，如果是首页加homeCloudsCount CLASS；其它页面加wmCloudsCount  CLASS -->
            <div class="flexbox wmCloudsCount homeCloudsCount resize-box-full">
              <!-- 邮件列表 -->
              <el-table
                ref="multipleTable"
                :data="tableData"
                class="nice_scroll el-table-full"
                tooltip-effect="dark"
                style="width: 100%;overflow-y: auto"
                @selection-change="handleSelectionChange"
                :show-header="false">
                <el-table-column
                  type="selection"
                  width="45">
                </el-table-column>
                <el-table-column
                  prop="name"
                  :label="$i18n.t('wm_lang_d7ec2d')">
                </el-table-column>
                <el-table-column
                  :label="$i18n.t('wm_lang_58f966')"
                  width="120"
                  show-overflow-tooltip>
                  <template slot-scope="scope">{{ bytesToSize(scope.row.size) }}</template>
                </el-table-column>
                <el-table-column
                  :label="$i18n.t('wm_lang_cae255')"
                  width="240">
                  <template slot-scope="scope">{{ $moment(scope.row.createDate).format('YYYY-MM-DD HH:mm') }}</template>
                </el-table-column>
                <el-table-column
                  :label="$i18n.t('wm_lang_2e42cc')"
                  width="240">
                  <template slot-scope="scope">{{ dateRemain(scope.row.expireDate) }}</template>
                </el-table-column>
                <el-table-column
                  :label="$i18n.t('wm_lang_2b6bc0')"
                  width="180">
                  <template slot-scope="scope">
                    <el-link type="primary" :underline="false" @click="attachDelay(scope.row.mailAccountFileId)">{{$t("wm_lang_html_9c51b4")}}</el-link>
                    <el-link type="primary" :underline="false" @click="attachDownload('single',scope.row.mailAccountFileId, scope.row.name)">{{$t("wm_lang_html_f26ef9")}}</el-link>
                    <el-link type="primary" :underline="false" @click="attachDelete('single',scope.row.mailAccountFileId)">{{$t("wm_lang_html_2f4aad")}}</el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 右侧页签 -->
          <!--<tabBar></tabBar>-->
        </div>
        <!--<app-footer></app-footer>-->
      </el-container>
    <!--</el-container>-->
  <!--</div>-->
  <!--</el-container>-->
  <!--</div>-->
</template>

<script>
  import Cookies from 'js-cookie';
  import AppHeader from '@/components/sub/Header.vue'
  import AppFooter from '@/components/sub/Footer.vue'
  import asideSet from '@/components/sub/asideSet.vue'
  import setBreadNav from '@/components/sub/setBreadNav.vue'
  import listBar from '@/components/sub/listBar.vue'
  import tabBar from '@/components/sub/tabBar.vue'
  import setComponent from "@/components/views/setBox/setComponent"
  import boxMail from "@/components/views/layout/boxMail"
  import boxRead from "@/components/views/layout/boxRead"
  import xmail from '@/api/api';
  import storeLocal from 'store';
  import { bytesToSize, downloadFile } from '@/utils/utils';

  export default {
    // name: 'layoutBoxMail',
    name: 'BoxMail',
    data () {
      return {
        configSetting: {},
        confDisplaySetting: {},
        totalPages: 0,
        currentPage: 1,
        pageSize: 0,
        pageNumbers:0,
        expDays: 0,
        layoutType: Cookies.get('Pwm-set-layout') ? Cookies.get('Pwm-set-layout') : 'lr',
        selectedAttach: [],
        showToolFilter: true,
        showToolAllCheck: true,
        tableData: [],
        freeSize: 0,
        totalSize: 0,
        usedSize: 0
      }
    },
    components:{
      setComponent,
      asideSet,
      setBreadNav,
      tabBar,
      listBar,
      boxRead,
      'app-header': AppHeader,
      'app-footer': AppFooter,
      boxMail
    },
    methods: {
      handleAllChecked(e) {
        // console.log(e.target.checked);
        if(e.target.checked) {
          this.allSelect();
        } else {
          this.notSelect();
        }
      },
      stopBubble(e) {
        e.stopPropagation();
      },
      checkedCommand(command) {
        switch (command) {
          case 'all':
            this.allSelect();
            break;
          case 'reverse':
            this.reverseSelect();
            break;
          case 'not':
            this.notSelect();
            break;
          default:
            return;
        }
      },
      allSelect() {
        this.$refs.multipleTable.toggleAllSelection();
      },
      reverseSelect() {
        this.tableData.forEach((item) => {
          this.$refs.multipleTable.toggleRowSelection(item);
        });
      },
      notSelect() {
        this.$refs.multipleTable.clearSelection();
      },
      refreshList() {
        this.largeAttachList();
      },
      toWrite() {
        this.$router.push({name: 'write', params: {type: 'write', largeAttach: this.selectedAttach}});
      },
      handleSelectionChange(val) {
        // console.log(val);
        this.selectedAttach = val;
      },
      attachDownload(type, id, fileName) {
        // const urlParams = storeLocal.get('Pwm-urlParams');
        // let params = {
        //   fileId: id,
        //   fileName: name
        // };
        // 后端需要get方式
        // let url = '/xmail/ms/v1/filetrans/downloadFile?fileId='+ id +'&fileName='+ name;
        // location.href = url;
        let downloadParam = [];
        if(type === 'single') {
          // downloadParam.push(id);
          const urlParams = storeLocal.get('Pwm-urlParams');
          let params = {
            mailAccountFileIds: [id]
          };
          (function (api, enums, pms) {
            let pm = pms.LargeFile.downloadFileParamBuilder();
            pm.mailAccountFileIds = [id];
            api.LargeFile.downloadFile(pm, function (res) {
              const data = res.data;
              if(data.code === 0) {
                window.open(data.data.url);
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
          // let url = '/xmail/wm/v1/large/file/downloadSingleFile'+ urlParams;
        } else {
          if(this.selectedAttach.length > 0) {
            downloadParam = this.selectedAttach.map(item =>{return item.mailAccountFileId});
            (function (api, enums, pms) {
              let pm = pms.LargeFile.downloadFileParamBuilder();
              pm.mailAccountFileIds = downloadParam;
              api.LargeFile.downloadFile(pm, function (res) {
                const data = res.data;
                if(data.code === 0) {
                  //
                }
              })
            })(xmail.api, xmail.enums, xmail.pms);
          } else {
            return;
          }
        }
      },
      bytesToSize(bytes) {
        return bytesToSize(bytes)
      },
      getPercent(num, total) {
        num = parseFloat(num);
        total = parseFloat(total);
        if (isNaN(num) || isNaN(total)) {
          return 0;
        }
        return total <= 0 ? "0%" : (Math.round(num / total * 10000) / 100.00);
      },
      dateRemain(endTime) {
        // 现在时间
        let now= new Date();
        //截止时间
        // let until= new Date(endTime);
        let until= endTime;
        let days = (until- now)/1000/3600/24;
        let day = Math.floor(days);
        let hours = (days - day)*24;
        let hour = Math.floor(hours);
        // let minutes = (hours - hour)*60;
        // let minute = Math.floor(minutes);
        // let seconds = (minutes - minute)*60;
        // let second = Math.floor(seconds);
        // let remain = this.$i18n.t('wm_lang_238ae0')+day+this.$i18n.t('wm_lang_249aba')+hour+this.$i18n.t('wm_lang_2de0d4')+minute+this.$i18n.t('wm_lang_3a17b7')+second+this.$i18n.t('wm_lang_0c1fec');
        let remain = this.$i18n.t('wm_lang_43b510')+day+this.$i18n.t('wm_lang_249aba')+hour+this.$i18n.t('wm_lang_87ba17');
        return remain;
      },
      largeAttachList(page) {
        let self = this;
        // 刷新列表
        (function (api, enums, pms) {
          let pm = pms.LargeFile.getFileListParamBuilder();
          pm.currentPage = page ? page : 0;
          let loading = self.$loading({text: self.$i18n.t('wm_lang_f013ea'), target: document.querySelector('.wmCloudsBox')});
          api.LargeFile.getFileList(pm, function (res) {
            const data = res.data;
            console.log(data)
            if(data.code === 0) {
              self.tableData = data.data.mailAccountFilePage.records;
              self.currentPage = data.data.mailAccountFilePage.current == 0 ? 1 : data.data.mailAccountFilePage.current;
              self.totalPages = data.data.mailAccountFilePage.pages == 0 ? 1 : data.data.mailAccountFilePage.pages;
              self.pageNumbers = self.makePageNumbers(data.data.mailAccountFilePage.pages);
              self.pageSize = data.data.mailAccountFilePage.size;
            }
            loading.close();
          })
        })(xmail.api, xmail.enums, xmail.pms);
        // 修改剩余空间数
        (function (api, enums, pms) {
          api.LargeFile.getSpaceInfo({}, function (res) {
            self.freeSize = res.data.data.freeSize;
            self.totalSize = res.data.data.totalSize;
            self.usedSize = res.data.data.usedSize;
          })
        })(xmail.api, xmail.enums, xmail.pms);
      },
      getTurnPrevFlag() {
        let flag = false;
        if(this.currentPage === 1){
          flag = true
        }
        return flag
      },
      getTurnNextFlag() {
        let flag = false;
        if(this.currentPage >= this.totalPages){
          flag = true
        }
        return flag
      },
      pageTurn(page) {
        if(page === 'next'){
          if(this.getTurnNextFlag()){
            return
          }
          this.currentPage = this.currentPage+1
        } else if(page === 'prev') {
          if(this.getTurnPrevFlag()){
            return
          }
          this.currentPage = this.currentPage-1
        } else {
          this.currentPage = page
        }
        this.largeAttachList(this.currentPage);
      },
      handlePageTurn(command) {
        this.currentPage = command;
        this.largeAttachList(command);
      },
      makePageNumbers(total) {
        let pNumbers = [];
        for(let i=0; i<total; i++){
          let item = {c: i+1, t: total}
          pNumbers.push(item);
        }
        return pNumbers;
      },
      attachDelete(type, id) {
        let delParam = [];
        if(type === 'single') {
          delParam.push(id);
        } else {
          if(this.selectedAttach.length > 0) {
            delParam = this.selectedAttach.map(item =>{return item.mailAccountFileId});
          } else {
            return;
          }
        }
        this.$confirm(this.$i18n.t('wm_lang_70a47f'), this.$i18n.t('wm_lang_c45357'), {
          confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
          cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          let self = this;
          (function (api, enums, pms) {
            let pm = pms.LargeFile.delFileParamBuilder();
            pm.mailAccountFileIds = delParam;
            api.LargeFile.delFile(pm, function (res) {
              const data = res.data;
              console.log(data)
              if(data.code === 0) {
                self.$message({
                  type: 'success',
                  message: self.$i18n.t('wm_lang_0007d1')
                });
                self.largeAttachList();
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        }).catch(() => {
          //
        });
      },
      attachDelay(id) {
        this.$confirm(this.$i18n.t('wm_lang_8a45a9'), this.$i18n.t('wm_lang_c45357'), {
          confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
          cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          let self = this;
          (function (api, enums, pms) {
            let pm = pms.LargeFile.delayFileParamBuilder();
            pm.mailAccountFileIds = [id];
            api.LargeFile.delayFile(pm, function (res) {
              const data = res.data;
              console.log(data)
              if(data.code === 0) {
                self.$message({
                  type: 'success',
                  message: self.$i18n.t('wm_lang_d41a62')
                });
                self.refreshList();
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        }).catch(() => {
          //
        });
      }
    },
    mounted(){
      this.configSetting = storeLocal.get('Pwm-configSetting');
      this.confDisplaySetting = this.configSetting.displaySetting;
      this.expDays = this.configSetting.deliverSetting.largeAttachExpireTime ? this.configSetting.deliverSetting.largeAttachExpireTime : 15
      this.largeAttachList();
    },
    computed: {
      moreActionBar() {
        return this.selectedAttach.length > 0;
      }
    },
    watch: {
      //
    }
  }
</script>

<style scoped>
  .wmCloudsWrapper{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/layout/largeAttach.vue